// @flow
import React, { Component } from 'react';
import { View, StyleSheet } from 'react-native';
import { Icon, TextInput } from './';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';

class SearchInput extends Component<Props> {
  styles = getStyles();
  render() {
    const styles = this.styles;
    return (
      <View style={styles.searchLine}>
        <Icon name="search" size={20} style={styles.searchIcon} />
        <TextInput
          {...this.props}
          style={styles.searchInput}
          autoCorrect={false}
          placeholder={I18n.t('search')}
          returnKeyType="go"
          underlineColorAndroid="transparent"
        />
      </View>
    );
  }
}

type Props = {
  onChangeText: Function,
  value: string,
};

const getStyles = () =>
  StyleSheet.create({
    searchInput: {
      color: theme.gray.normalLight,
      fontSize: 15,
      height: 50,
    },
    searchLine: {
      backgroundColor: theme.gray.lightBackground,
      height: 50,
      flexDirection: 'row',
      alignItems: 'center',
    },
    searchIcon: {
      paddingTop: 3,
      marginLeft: 10,
      marginRight: 16,
    },
  });
export default SearchInput;
